// import * as accountingMocks from './api/accountingMocks'
// import * as agencyMocks from './api/agencyMocks'
// import * as invoiceMocks from './api/invoiceMocks'
// import * as partyMocks from './api/partyMocks'
// import * as portfolioMocks from './api/portfolioMocks'
// import * as propertyMocks from './api/propertyMocks'
// import * as reconMocks from './api/reconMocks'
// import * as tpnMocks from './api/tpnMocks'
// import * as userMocks from './api/userMocks'
// import * as walletMocks from './api/walletMocks'

export const handlers = [
  // propertyMocks.searchProperties.success,
  // propertyMocks.propertyResponse.success,
  // propertyMocks.createProperty.success,
  // propertyMocks.placeResponse.success,
  // invoiceMocks.bulkSendInvoices.partialErrors,
  // walletMocks.payout.success,
  // agencyMocks.agencyListing.success
  // walletMocks.refund.errors.unknownError
  // partyMocks.getSuspenseAccountFuzzyMatches.success
  // portfolioMocks.addInvoiceTemplate.error409
  // portfolioMocks.applications.getPortfolioWithApplications,
  // portfolioMocks.applications.acceptApplication,
  // portfolioMocks.applications.deleteApplications,
  // portfolioMocks.applications.getPortfolioWithoutApplications,
  // portfolioMocks.applications.createApplication,
  // walletMocks.bulkWalletTransfer.success,
  //
  // /admin/billing against fixtures. Enable BOTH together — the update epic
  // re-requests the settings, so mocking only the write leaves the page
  // showing a stale number.
  // accountingMocks.billingAgencySettings.success,
  // accountingMocks.updateBillingInvoiceNumber.success,
  //
  // TPN report card on /integrations. Pick ONE tpnSettings handler; the write
  // handlers re-request settings, so the card shows whatever that one answers.
  // tpnMocks.tpnSettings.connected,
  // tpnMocks.saveTpnSettings.success,
  // tpnMocks.removeTpnSettings.success,
  // tpnMocks.setTpnAutoSend.success,
  // tpnMocks.sendTpnReport.success,
]
